import React from 'react';
import PropTypes from 'prop-types';
 
export default class HundredsHeroes extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isKorea: PropTypes.bool,
        buttonContainer: PropTypes.node
    };
    render() {
        const {title, description, title1, title2} = this.props.content;
        const {buttonContainer, isKorea} = this.props;
        return (
            <div className="hundreds-heroes container-fluid">
                <div className="background" />
                <div className="heroes" />
                <div className={`content ${isKorea ? 'koreanCountry' : '' }`}>
                    <h1>{title1 && title2 ? <>{title1}<br></br>{title2}</> : title}</h1>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                    {buttonContainer}
                </div>
            </div>
        );
    }
}

